<template>
  <section>
    <m-table-list
      ref="tableList"
      :fetch-list-func="fetchListFunc"
      :search-form.sync="filters"
    >
      <template v-slot:search-items>
        <m-search-panel
          @searchBoxChange="handleSearch"
          isShowOpenButton
          @keyup.enter.native="handleSearch()"
        >
          <div slot="title">数据筛选</div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">工单分类</div>
                <!-- <el-input v-model="filters.parentQaTypeName"></el-input> -->
                <el-select
                  v-model="filters.parentTypeId"
                  placeholder="工单分类"
                  @change="workCutChange($event)"
                >
                  <el-option
                    v-for="(item, index) in workCutList"
                    :key="index"
                    :value="item.parentTypeId"
                    :label="item.parentQaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">工单类型</div>
                <el-select
                  :disabled="workTypeFlag"
                  v-model="filters.qaTypeId"
                  placeholder="工单类型"
                >
                  <el-option
                    v-for="(item, index) in workTypeList"
                    :key="index"
                    :value="item.qaTypeId"
                    :label="item.qaTypeName"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">启用状态</div>
                <el-select v-model="filters.status" placeholder="启用状态">
                  <el-option
                    v-for="(item, index) in dialogTypeEnum"
                    :key="index"
                    :value="item.code"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </div>
              <div class="filter-item">
                <div class="demonstration">承接人</div>
                <el-input
                  v-model="filters.considerUserName"
                  style="min-width: 90px"
                  placeholder=""
                ></el-input>
              </div>
            </div>
            <div class="filter-item buttons">
              <el-button
                type="primary"
                size="small"
                class="query-btn"
                @click="handleSearch"
                >查询</el-button
              >
              <el-button
                type="primary"
                size="small"
                plain
                @click="handleClearSearchForm"
                >重置</el-button
              >
              <!-- <el-button  class="query-btn" @click="$router.push({name: 'work.details'})">新建</el-button> -->
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
          <div class="left">
            <el-button
              type="primary"
              size="small"
              class="add-btn"
              @click="handleShowLog(undefined)"
              >+添加
            </el-button>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column
          label="工单分类"
          prop="parentQaTypeName"
          show-overflow-tooltip
          width="204px"
        ></el-table-column>
        <el-table-column
          label="工单类型"
          prop="qaTypeName"
          show-overflow-tooltip
          width="180px"
        ></el-table-column>
        <el-table-column
          label="生成时间"
          prop="created"
          show-overflow-tooltip
          width="251px"
        >
          <template slot-scope="{ row }">{{
            row.created | dateTime("yyyy-MM-dd hh:mm")
          }}</template>
        </el-table-column>
        <el-table-column
          label="承接人"
          prop="problemAcceptor"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <div v-if="row.acceptorMode=='SPECIFIC'">
              <span>
                {{
                  row.problemAcceptor &&
                  row.problemAcceptor
                    .slice(0, 10)
                    .map((item) => item.userName)
                    .join("、")
                }}
              </span>
              <span v-if="row.problemAcceptor && row.problemAcceptor.length > 10"
                >...</span
              >
            </div>
            <div v-else>
              <span>{{ convertAcceptorMode(row.acceptorMode) || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="启用状态"
          prop="status"
          show-overflow-tooltip
          width="140px"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">否</span>
            <span v-if="scope.row.status == 1">是</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template v-if="row.handlerType === 'NORMAL'" slot-scope="{ row }">
            <el-button type="text" @click.native="handleShowLog(row)"
              >信息配置</el-button
            >
            <el-button
              type="text"
              v-if="row.parentQaTypeId !== '-1'"
              @click="del(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </template>
    </m-table-list>
    <!-- <el-button icon="el-icon-check" round :indeterminate="isIndeterminate" v-model="checkAll" @click="selAll()">全选</el-button> -->
    <!-- <el-button icon="el-icon-finished" round @click="unselAll(tableData)">反选</el-button> -->

    <!-- <m-log :targetId="targetId" :showVisible="logDisplay" @close="logDisplay = false"></m-log> -->
  </section>
</template>
<script>
import tableList from "components/tableList";
import api from "plus/api";
import { scrollTo } from "@/utils/scroll-to";

export default {
  name: "privilege.questionSetting.list",
  data() {
    return {
      workTypeFlag: true,
      workTypeList: [],
      workCutList: [],
      filters: {
        parentQaTypeName: "",
        status: "",
        pageNo: 1,
        pageSize: 10,
        qaTypeId: "",
        parentTypeId: "",
      },
      dialogTypeEnum: [
        {
          name: "启用",
          code: 1,
        },
        {
          name: "禁用",
          code: 0,
        },
      ],
    };
  },
  activated() {
    scrollTo(0, 0);
    this.getDropDownList();
    //  this.getData();
  },
  deactivated() {
    this.workTypeFlag = true;
    this.workTypeList = [];
    this.workCutList = [];
    this.filters = {
      parentQaTypeName: "",
      status: "",
      pageNo: 1,
      pageSize: 10,
      qaTypeId: "",
      parentTypeId: "",
    };
    this.dialogTypeEnum = [
      {
        name: "启用",
        code: 1,
      },
      {
        name: "禁用",
        code: 0,
      },
    ];
  },
  components: {
    "m-table-list": tableList,
  },
  computed: {},
  created() {},
  methods: {
    fetchListFunc: api.privilege.getQuestSetting,
    resetData() {},
    // 删除
    del(val) {
      if (val.parentQaTypeId == "-1") {
        this.$message({
          type: "warning",
          message: "该行数据不能删除!",
        });
      } else {
        this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          confirmButtonClass: "confirmBtn",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let params = {
              id: val.id,
            };
            api.privilege.delSetting(params).then((res) => {
              this.$refs.tableList.getMainData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //分类改变引起类型改变
    workCutChange(e) {
      let filters = {
        id: e,
      };
      this.filters.qaTypeId = "";
      api.dropDownList.getWorkType(filters).then((res) => {
        this.workTypeList = res.data.data;
        this.workTypeFlag = false;
        // ;
        // ;
      });
    },
    getDropDownList() {
      // api.getDropDownList.getWorkType
      api.dropDownList.getWorkCut().then((res) => {
        //工单分类下拉
        this.workCutList = res.data.data;
      });
    },
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleShowLog(val) {
      // this.$router.push({
      //     name: "privilege.questionSetting.add",
      //     query: {
      //         parentQaTypeName: val.parentQaTypeName,
      //         id: val.id,
      //         type: "updata",
      //     },
      // });
      // 获取路由对应的路径
      const routePath = this.$router.resolve({
        name: "privilege.questionSetting.add",
        query: {
          id: val?.id,
        },
      }).href;

      // 在新窗口打开页面
      window.open(routePath, "_blank");
    },
    handleClearSearchForm() {
      this.workTypeFlag = true;
      this.$refs.tableList.resetSearchForm();
    },
    convertAcceptorMode(acceptorMode){
      if(acceptorMode == 'COMPANY_BUSINESS_MANAGER') return '机构商务负责人';
      if(acceptorMode == 'REGIONAL_BUSINESS_BUSINESS_MANAGER') return '区域业务商务负责人';
      if(acceptorMode == 'CUSTOMER_CONSULTING') return '客户所属咨询';
      if(acceptorMode == 'CUSTOMER_CONSULTING_SUPERVISOR') return '客户所属咨询主管';
      return '-';
    }
  },
};
</script>
<style lang="less" scoped>
.wap {
  .page {
    color: red;
  }
}
</style>
